{
  "help-menu": {
    "about-this-page": "About this page",
    "aria-label": "Help Menu",
    "help": "Help Center",
    "partner": "Partner Portal",
    "status": "Bigleaf Network Status",
    "submit": "Submit Ticket",
    "versa_pay": "Versapay Billing"
  },
  "logged-as-banner": {
    "logout-button": "Logout from this account",
    "text": "You are logged in as <span>{{fullName}}</span>"
  },
  "navigation-links": {
    "accounts": {
      "altText": "User account information",
      "text": "Accounts"
    },
    "alerts": {
      "altText": "Alerts",
      "text": "Alerts"
    },
    "companies": {
      "altText": "Companies",
      "text": "Companies"
    },
    "configuration": {
      "altText": "Site configuration settings",
      "text": "Site Configuration"
    },
    "dashboard": {
      "altText": "Open the Dashboard",
      "text": "Dashboard"
    },
    "insights": {
      "altText": "Alerts, events, and actions",
      "text": "Insights"
    },
    "logs": {
      "altText": "Access log files",
      "text": "Logs"
    },
    "overview": {
      "altText": "Overview",
      "text": "Overview"
    },
    "performance": {
      "altText": "Network performance for a site",
      "text": "Performance"
    },
    "profile": {
      "altText": "User profile",
      "text": "Profile"
    },
    "settings": {
      "altText": "Configure user account settings",
      "text": "User Settings"
    },
    "sign-out": {
      "altText": "Sign out",
      "text": "Sign out"
    },
    "sites-monitoring": {
      "altText": "Open Sites",
      "text": "Sites"
    },
    "support": {
      "altText": "Access Support",
      "text": "Support"
    },
    "troubleshooting": {
      "altText": "Troubleshoot site issues",
      "text": "Troubleshooting"
    },
    "users": {
      "altText": "Manage user accounts",
      "text": "Users"
    }
  },
  "navigation-menu": {
    "collapse": "Hide menu",
    "expand": "Expand menu"
  },
  "search-bar": {
    "companies": "Companies",
    "no-results-found": {
      "companies": "No Companies Found",
      "recent": "No Recent Sites",
      "sites": "No Sites Found"
    },
    "placeholder": "Search",
    "recent": "Recently Selected",
    "sites": "Sites"
  },
  "user-menu": {
    "aria-label": "User Menu",
    "switch-to-v1-toggle": "Bigleaf new look"
  }
}
